"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Skills;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SkillsModule = _interopRequireDefault(require("./Skills.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _entities = require("../../../../../../entities");

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Skills(_ref) {
  var _ref$hp = _ref.hp,
      hp = _ref$hp === void 0 ? 0 : _ref$hp,
      _ref$hpMax = _ref.hpMax,
      hpMax = _ref$hpMax === void 0 ? 0 : _ref$hpMax,
      _ref$skills = _ref.skills,
      skills = _ref$skills === void 0 ? [] : _ref$skills,
      onToggleAutoAttack = _ref.onToggleAutoAttack,
      onToggleAutoSkill = _ref.onToggleAutoSkill,
      onClickSkill = _ref.onClickSkill,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isAutoAttack = _useState2[0],
      setIsAutoAttack = _useState2[1]; // TODO: remove, get from props


  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAutoSkill = _useState4[0],
      setIsAutoSkill = _useState4[1]; // TODO: remove, get from props


  var hpBarPec = Math.round(100 / hpMax * hp);
  var toggleAutoAttack = (0, _react.useCallback)(function () {
    setIsAutoAttack(!isAutoAttack);
    if (onToggleAutoAttack) onToggleAutoAttack(!isAutoAttack);
  }, [isAutoAttack, onToggleAutoAttack]);
  var toggleAutoSkill = (0, _react.useCallback)(function () {
    setIsAutoSkill(!isAutoSkill);
    if (onToggleAutoSkill) onToggleAutoSkill(!isAutoSkill);
  }, [isAutoSkill, onToggleAutoSkill]);
  var renderSkills = (0, _react.useCallback)(function () {
    if (skills.length > 5) {
      throw new Error("Unable to render more than 5 skills for mercenary. ".concat(skills.length, " were given."));
    }

    return skills.map(function (skill, i) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: skill.id,
        className: (0, _classnames.default)(_SkillsModule.default.skill, _SkillsModule.default["skill".concat(i + 1)]),
        onClick: function onClick() {
          if (onClickSkill) onClickSkill(i);
        }
      }, /*#__PURE__*/_react.default.createElement(_entities.ClassSkill, {
        skill: skill
      }));
    });
  }, [skills, onClickSkill]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SkillsModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillsModule.default.hpBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillsModule.default.fill,
    style: {
      width: "".concat(hpBarPec, "%")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillsModule.default.value
  }, hp, " / ", hpMax)), renderSkills(), /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillsModule.default.autoAttackBtn
  }, isAutoAttack && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HI_AUTO_ATTACK_21X21,
    onClick: toggleAutoAttack
  }), !isAutoAttack && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.DEF_AUTO_ATTACK_21X21,
    onClick: toggleAutoAttack
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillsModule.default.autoMagicBtn
  }, isAutoSkill && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HI_AUTO_SKILL_21X21,
    onClick: toggleAutoSkill
  }), !isAutoSkill && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.DEF_AUTO_SKILL_21X21,
    onClick: toggleAutoSkill
  })));
}